import React, { Component } from "react";

import { Button, Form, Segment } from "semantic-ui-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
// import { Slider } from 'react-semantic-ui-range'
// import Slider from 'react-rangeslider'
import colors from "../../colors";

library.add(faAngleDoubleLeft, faAngleDoubleRight);

class DateSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //    slideTracker:0
    };
  }

  render() {
    return (
      <Segment
        style={{
          backgroundColor: "#fff",
          width: "350px",
          padding: "0px",
          marginLeft: "-5px",
        }}
      >
        <div style={{ backgroundColor: "#fff", display: "flex" }}>
          <div
            style={{
              width: "28.5%",
              paddingLeft: "0.5%",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {this.props.date}
          </div>
          <div style={{ width: "5%" }}>
            {/* <Popup
                        trigger={ */}
            <Button
              size="tiny"
              secondary
              compact
              style={{ padding: "5px", backgroundColor: colors.sidebar }}
              onClick={this.props.onClickSlideLeft}
              floated="right"
            >
              <FontAwesomeIcon icon="angle-double-left" size="lg" />
            </Button>
            {/* }
                        position='top center'
                    >
                        <Popup.Content>Move One Day Backward</Popup.Content>
                    </Popup> */}
          </div>
          <div style={{ width: "60%" }}>
            {this.props.slideTracker > -1 ? (
              <Form>
                <input
                  className="slider"
                  type="range"
                  value={this.props.slideTracker}
                  start={this.props.slideTracker}
                  min={0}
                  max={this.props.max}
                  step={1}
                  onChange={this.props.onSlide}
                />
              </Form>
            ) : // <Slider

            //     color="blue"
            //     inverted={false}
            //     style={{
            //         pointerEvents:'all',
            //         touchAction:'auto',

            //     }}
            //     value={this.props.slideTracker}
            //     settings={{
            //         start:this.props.slideTracker,
            //         min:0,
            //         max:this.props.max,
            //         step:1,
            //         onChange: this.props.onSlide,
            //         smooth: true,
            //     }}
            //     // settings={this.props.settings}
            // />

            null}
          </div>
          <div style={{ width: "5%" }}>
            {/* <Popup
                        trigger={ */}
            <Button
              size="tiny"
              secondary
              compact
              style={{ padding: "5px", backgroundColor: colors.sidebar }}
              onClick={this.props.onClickSlideRight}
            >
              <FontAwesomeIcon icon="angle-double-right" size="lg" />
            </Button>
            {/* }
                        position='top center'
                    >
                        <Popup.Content>Move One Day Forward</Popup.Content>
                    </Popup> */}
          </div>
        </div>
      </Segment>
    );
  }
}

export default DateSlider;